import store from "store2";

export default function hasAccess(module) {
  const user = store.session.get("user");

  const index = user?.modules?.findIndex((el) => el.name === module);

  return typeof index !== "undefined" && index >= 0;
}
